export enum SvcModule {
  Authentication,
  MyWorkspace,
  Praise,
  Communication,
  Survey,
  Quiz,
  Notification,
  Users,
  Rca,
  Alert,
  BOS,
  Multilingual,
  ExternalFeatures,
  Copilot,
  Lpp,
  UnsafeCondition,
  DefectTag,
  Scorecard,
  Feed,
  Administration,
  ActionPlan,
  Cil,
  DigitalObeya,
  KnowledgeCenter,
}
